import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type THIS_API = ApiDefinition['/bank-account-integrations/{bankAccountIntegrationId}/permissions']['PUT'];
type Input = THIS_API['params'] & THIS_API['body'];
type Output = THIS_API['response'];

const updateBankAccountIntegrationPermissions = async ({
  bankAccountIntegrationId,
  userIds,
}: Input): Promise<Output> => {
  const response = await noodleApiClient.put(`/bank-account-integrations/${bankAccountIntegrationId}/permissions`, {
    userIds,
  });
  return response.data;
};

export default updateBankAccountIntegrationPermissions;
